module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.svg
// module chunks = styles